import React, { useEffect, useState } from 'react';
import CardProducts from './CardProducts';
import GetProducts from '../services/product.services';
import '../styles/cardProducts.css';
import { Container, Row, Col } from 'react-bootstrap';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Cookies from "universal-cookie";

// Move calculateSlidesToShow outside of useEffect
const calculateSlidesToShow = (width) => {
  return width <= 390 ? 1 : 3; // 1 for small screens, 3 for larger screens
};

function ViewProducts() {
  const cookies = new Cookies();
  const token = cookies.get("token");
  const [products, setProducts] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: calculateSlidesToShow(windowWidth),
  };

  const fetchProducts = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
    };
    try {
      const response = await fetch(`${GetProducts.RUTA_API_Products}`, requestOptions);
      if (!response.ok) {
        const errorMessage = await response.text();
        console.error("Error fetching products:", errorMessage);
        throw new Error("Error fetching products");
      }

      const data = await response.json();
      setProducts(data);
      //setFilteredProducts(data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Container fluid id="Products">
      <div className='titleH2'>
        <h2>Productos</h2>
      </div>
      <Slider {...settings}>
        {products.map((product, index) => (
          <Col key={index} className='d-flex justify-content-center'>
            <CardProducts product={product} />
          </Col>
        ))}
      </Slider>
    </Container>
  );
}

export default ViewProducts;
